import styled from 'styled-components';

const DisclaimerStyles = styled.section`
  padding: 3.1875rem ${props => props.theme.padding.inner};
  background: ${props => props.backgroundColor ? props.backgroundColor : props.background || props.theme.colors.darkBlue};
  
  .inner {
    margin: auto;
    max-width: ${props => props.theme.maxWidths.containerSmall};
    color: ${props => props.textColor ? `${props.textColor} !important` : (props.$data.dark ? 'black !important' : '')};
        
    p {
      font-size: ${props => props.theme.type.paragraph.xs};
      line-height: ${props => props.theme.lineHeights.paragraph.xs};
      letter-spacing: ${props => props.theme.letterSpacing.paragraph};
      color: ${props => props.textColor ? `${props.textColor} !important` : (props.$data.dark ? 'black !important' : '')};
      align-items: ${props => props.$data?.alignText === "Center Align" ? "center" : props.$data?.alignText === "Right Align" ? "flex-end" : "flex-start"};
      text-align: ${props => props.$data?.alignText === "Center Align" ? "center" : props.$data?.alignText === "Right Align" ? "right" : "left"};

      a {
        color: ${props => props.textColor ? `${props.textColor} !important` : (props.$data.dark ? 'black !important' : '')};
      }
      
    }

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: 1228px;
    }
  }
`;

export default DisclaimerStyles;
